<template>
    <div
        :class="['container', { success: props.status == PaymentStatuses.success, failure: props.status == PaymentStatuses.fail }]">
        <div>
            <div class="beaming-icon-container">
                <div class="beaming-icon h-20px">
                    <div class="pulse"></div>
                    <div class="pulse"></div>
                    <div class="pulse"></div>
                    <img :src="loadFile(props.status == PaymentStatuses.success ? images.success : images.failure)"
                        :alt="props.status">
                </div>
            </div>
        </div>
        <div>
            <div class="messageTitle">
                {{ $t(status == PaymentStatuses.success ? "Payment Succeeded" : 'Payment Failed') }}
            </div>
            <div class="messageContent">
                {{ props.message }}
            </div>
        </div>
    </div>
</template>

<script setup>
import { PaymentStatuses } from '@/components/whatsapp-managment/interfaces.js'

const props = defineProps({
    status: String,
    message: String
});

const images = {
    failure: 'alert-circle.svg',
    success: 'check-circle.svg'
}

const loadFile = (fileName) => {
    return window.location.origin + "/assets/image/" + fileName;
}

</script>

<style scoped lang="scss">
@import './styles/paymentResponse.scss';
</style>
